import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";
import { createSharedCostByDimensionAndCategoryIdsThunk } from "@/store/dimensions/thunks/shared-costs/createSharedCostByDimensionAndCategoryIdsThunk";
import { dimensionSharedCostsDataSelector } from "@/store/dimensions/selectors/shared-costs/dimensionSharedCostsDataSelector";
import { convertSharedCostsArrayToObjectByIds } from "@/store/dimensions/thunks/dimensions/update-current-dimension/shared-costs/convertSharedCostsArrayToObjectByIds";

export const findAndCreateNewAddedSharedCostsThunk = createAsyncThunk(
  "dimensions/findAndCreateNewAddedSharedCosts",
  async (dimensionId: string, { dispatch, getState }) => {
    const state = getState() as RootState;
    const dimensionSharedCosts = dimensionSharedCostsSelector(state);

    if (!dimensionId) {
      return;
    }

    const originalSharedCosts = dimensionSharedCostsDataSelector(state);

    const sharedCostsObject =
      convertSharedCostsArrayToObjectByIds(originalSharedCosts);

    const newAddedSharedCosts = dimensionSharedCosts.filter(
      (cost) => !sharedCostsObject[cost.id],
    );

    if (!newAddedSharedCosts.length) {
      return;
    }

    dispatch(
      createSharedCostByDimensionAndCategoryIdsThunk({
        dimensionId,
        sharedCosts: newAddedSharedCosts,
      }),
    );
  },
);
